module.exports = __webpack_public_path__ + "static/24-823eea2b467bb12d3e6c02b4213b8cf8.jpg";